/** @format */

if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
  $(".open_gallery").on("click", function () {
    $(".fancybox")[0].click();
  });
  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );
  // Booking Full Screen
  $(".rfp-call").click(function () {
    $(this).toggleClass("active");
    $("#booking-container").toggleClass("open");
    $(".btn-default").fadeToggle();
    $(".btn-close").fadeToggle();
  });

  $(".sym-slides").slick({
    accessibility: false,
  });

  $(".acc-btn").click(function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next().slideToggle();
    } else {
      $(".acc-btn").removeClass("active");
      $(".tab-content").slideUp();
      $(this).addClass("active");
      $(this).next().slideToggle();
    }
  });
  $(".slider-images").slick({
    accessibility: true,
    fade: true,
    arrows: false,
    swipe: false,
    speed: 500,
    autoplaySpeed: 3000,
    dots: false,
    slidesToShow: 1,
    infinte: false,
    adaptiveHeight: false,
  });

  $(".slick-tabs").slick({
    dots: true,
    focusOnSelect: true,
    infinite: true,
    arrows: false,
    customPaging: function (slider, i) {
      let title = $(slider.$slides[i]).data("title");
      return '<a class="locations-nav__page-item"> ' + title + " </a>";
    },
  });
  $(".slider-cards__sliders").slick({
    accessibility: false,
    asNavFor: ".slider-cards__sliderp",
    arrows: false,
    slidesToScroll: 1,
    variableWidth: false,
    fade: true,
  });

  $(".slider-cards__sliderp")
    .on("init", function (event, slick) {})
    .slick({});
})();
